"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  button: "That's ok with me",
  notice: "Hello! Our website uses cookies to help us provide you with the best user experience\n    and to deliver customised experiences. You can find out more about the cookies we use and your\n    cookie choices, <a href=\"https://pod-point.com/technical/privacy-policy\" target=\"_blank\">here</a>.\n    If you continue to use our services, we'll assume you're ok with this."
};
module.exports = exports["default"];